module.exports = __webpack_public_path__ + "assets/img/html.099c9459.svg";